import { useEffect, useState } from 'react';
import { getBeaconMode, onBeaconModeChange } from '../lib/proximity/beaconPrivacy';

/** This phone's Find beacon mode ('off' | 'shadow' | 'on'), live as Settings changes it. */
export function useBeaconMode() {
  const [mode, setMode] = useState(getBeaconMode);
  useEffect(() => onBeaconModeChange(setMode), []);
  return mode;
}
